export default __webpack_public_path__ + "static/media/alert.409a8e37.svg";